import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { App } from "antd";
import { useDispatch } from "react-redux";

import { logout } from "@/redux/authentication/reducer";
import { LocalStorageName } from "@/redux/api";
import { useLogOutMutation } from "@/redux/service";

export const useAccountSignOut = () => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logOut] = useLogOutMutation();

  return useCallback(() => {
    logOut(null)
      .unwrap()
      .then(() => {
        dispatch(logout());
        notification.success({ message: t("account.signOutSuccess") });
        globalThis.localStorage.removeItem(LocalStorageName);
        navigate("/login");
      });
  }, [logOut, dispatch, notification, t, navigate]);
};
